window.intercomSettings = {
  api_base: 'https://api-iam.intercom.io',
  app_id: 'gwncdo0l',
};

(function () {
  var intercom = window.Intercom;
  if (typeof intercom === 'function') {
    intercom('reattach_activator');
    intercom('update', window.intercomSettings);
  } else {
    var intercomStub = function () {
      intercomStub.c(arguments);
    };
    intercomStub.q = [];
    intercomStub.c = function (args) {
      intercomStub.q.push(args);
    };
    window.Intercom = intercomStub;
  }
})();
